var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_89_1574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.242218H23.9532V16.5499H0V0.242218Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.242218H23.9532V4.59094H0V0.242218ZM0 12.2012H23.9532V16.5499H0V12.2012Z",
    fill: "#D03433"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 4.58142H23.9532V12.2108H0V4.58142Z",
    fill: "#FBCA46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.30371 7.85248H9.3683V8.39607H8.30371V7.85248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.66512 9.48326C7.66512 9.80941 7.9845 10.0269 8.30387 10.0269C8.62325 10.0269 8.94262 9.80941 8.94262 9.48326L9.04908 7.85249H7.55866L7.66512 9.48326ZM7.02637 7.85249C7.02637 7.52634 7.23928 7.3089 7.4522 7.3089H9.04908C9.36846 7.3089 9.58138 7.52634 9.58138 7.74377V7.85249L9.47492 9.48326C9.36846 10.1356 8.94262 10.5704 8.30387 10.5704C7.66512 10.5704 7.23928 10.1356 7.13283 9.48326L7.02637 7.85249Z",
    fill: "#A41517"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23946 8.39608H9.36863V8.93967H8.83634L8.30405 10.0269L7.77175 8.93967H7.23946V8.39608ZM5.64258 6.76531H6.70717V10.5704H5.64258V6.76531ZM9.90093 6.76531H10.9655V10.5704H9.90093V6.76531ZM7.23946 6.22172C7.23946 5.89557 7.45238 5.67813 7.77175 5.67813H8.83634C9.15572 5.67813 9.36863 5.89557 9.36863 6.22172V6.43916C9.36863 6.65659 9.26218 6.76531 9.04926 6.76531H7.45238C7.34592 6.76531 7.23946 6.65659 7.23946 6.54788V6.22172Z",
    fill: "#A41517"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_89_1574"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16.3077,
    fill: "white",
    transform: "translate(0 0.230774)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEs);
export default __webpack_public_path__ + "static/media/ES.d352032922e2d6204528ced439546692.svg";
export { ForwardRef as ReactComponent };